// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_2hr5j","image":"_2Pyhm","imageFit":"EMdzY","titleContainer":"_1GlQZ","title":"_2T0NL"};